"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PtSmasLogisticWorldwide = void 0;
exports.PtSmasLogisticWorldwide = {
    id: 'ptSmasLogisticWorldwide',
    companyName: 'PT. SMAS Logistic Worldwide',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'ptSmasLogisticWorldwide',
    },
    isInternal: false,
    isActive: true,
    countries: ['ID'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHRTbWFzTG9naXN0aWNXb3JsZHdpZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvYWdlbnRzL2RhdGEvUHRTbWFzTG9naXN0aWNXb3JsZHdpZGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSx1QkFBdUIsR0FBVTtJQUMxQyxFQUFFLEVBQUUseUJBQXlCO0lBQzdCLFdBQVcsRUFBRSw2QkFBNkI7SUFDMUMsY0FBYyxFQUFFLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQztJQUM5QixXQUFXLEVBQUU7UUFDVCxXQUFXLEVBQUUsSUFBSTtRQUNqQixLQUFLLEVBQUUseUJBQXlCO0tBQ25DO0lBQ0QsVUFBVSxFQUFFLEtBQUs7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxTQUFTLEVBQUUsQ0FBQyxJQUFJLENBQUM7Q0FDcEIsQ0FBQSJ9